interface EndInterviewDialogProps {
  onCancel: () => void
  onConfirm: () => void
}

export function EndInterviewDialog({ onCancel, onConfirm }: EndInterviewDialogProps) {
  return (
    <div className="absolute inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-md animate-fade-in">
      <div className="bg-black border-none p-10 rounded-3xl shadow-2xl max-w-sm text-center transform scale-100 animate-bounce-in relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-500 to-accent-500" />
        <div className="absolute -top-10 -right-10 w-24 h-24 bg-white/5 rounded-full blur-2xl" />
        <h3 className="text-2xl font-bold text-white mb-3">End Interview?</h3>
        <p className="text-gray-400 mb-8 text-sm leading-relaxed">
          Are you sure you want to end the call? All session progress will be finalized.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={onConfirm}
            className="w-full py-4 rounded-xl bg-gradient-to-r from-brand-600 to-brand-500 text-white font-bold text-base hover:from-brand-500 hover:to-brand-400 transition-all shadow-lg shadow-brand-500/20 tracking-wide"
          >
            Yes, End Interview
          </button>
          <button
            onClick={onCancel}
            className="w-full py-3 rounded-xl bg-transparent text-gray-500 font-medium hover:text-white hover:bg-white/5 transition-colors text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
